import React, { Component,ReactElement,useState } from "react";

import PageLayout from '../../components/layout/PageLayout'
import {ThemeProps} from "../../components/styles/themeprops";
import { Fade } from "react-awesome-reveal";
import {
  servicePageHeader,
  serviceSkills,
} from "../../portfolio";
import "./auszubildende.css";
import ServiceImg from "./auszubildendeImg";
import { patiApi } from '../../components/misc/PatiApi'
import {handleLogError} from "../../components/misc/Helpers";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Link from "../../components/html/link";

import Branchenkompetenz from "./Branchenkompetenz"

type ContactFormData = {
  [key: string]: any; 
}
type LoginRequestState = { running?: boolean,isError?:boolean, error?: string,successful?:boolean,message?:string,};
type Props = {theme: ThemeProps,}
type SSkils = {
  skillName: string,
  fontAwesomeClassname?: string,
  imageSrc?:string,
  style?: {
  },
}
export default function Service({ theme }: Props) {
		const { t, i18n } = useTranslation();
    const [inputFields, setInputFields] = useState<ContactFormData>({title:"",name:"",organisation:"",phone:"",email:"",message:"",errors:{}});
    const [loginRequestState,setLoginRequestState,] = React.useState<LoginRequestState>({ running: false});
    
    const handleLoginT = (event:React.FormEvent<HTMLFormElement>) => {
			event.preventDefault();
			console.log(inputFields);
			const errorsN:ContactFormData = {};
			for (const el of document.getElementById('form')!.querySelectorAll("[required]")) {
			  if (!(el as HTMLInputElement).reportValidity()) {
			    errorsN[(el as HTMLInputElement).name] = 'invalid';
			  }
  		}
  		inputFields.errors=errorsN;
  		setInputFields(inputFields);
		}
    
    const handleFormChange = (event:React.ChangeEvent<HTMLInputElement>) => {
		   inputFields[event.target.name] = event.target.value;
		   setInputFields(inputFields);
		}
		
    async function handleLogin(event:React.FormEvent<HTMLFormElement>) {
			event.preventDefault();
			console.log(inputFields);
			const errorsN:ContactFormData = {};
			for (const el of document.getElementById('form')!.querySelectorAll("[required]")) {
			  if (!(el as HTMLInputElement).reportValidity()) {
			    errorsN[(el as HTMLInputElement).name] = 'invalid';
			  }
  		}
  		inputFields.errors=errorsN;
  		setInputFields(inputFields);
			
			setLoginRequestState({
				running: true,
			});
			if (!(inputFields.email ||  inputFields.name || inputFields.phone || inputFields.message)) {
				console.log("ERRRRRRRRRRRRR");
				setLoginRequestState({ isError: true,});
				return
			}
	
			patiApi.contact(document.querySelector("form.contactform")!)
				.then(response => {
					setLoginRequestState({
						isError: false,
	          message: response.data,
	          successful: true
					})
				}).catch(error => {
					handleLogError(error)
					setLoginRequestState({ isError: true })
				})
		}
		
		function renderServerError(): ReactElement {
        return (
            <p className="error-message">
              Something went wrong. Please try again later.
            </p>
        )
    }  

		
    return (
		<PageLayout title="Home" theme={theme}>
      <div className="projects-main">
        <div className="basic-projects">
          <Fade direction="left" duration={1000} damping={0.3} triggerOnce={true}>
            <div className="projects-heading-div">
              <div className="projects-heading-img-div">
                <ServiceImg theme={theme} />
              </div>
              <div className="projects-heading-text-div">
                <h1 className="projects-heading-text">{t('leistung.title')}</h1>
                <p className="projects-header-detail-text subTitle">
								<div dangerouslySetInnerHTML={
								    {__html: t('leistung.desc', {interpolation: {escapeValue: false}})}
								} />
								
                	
                </p>
                <div className="portfolio-repo-btn-div" style={{display:"flex",justifyContent:"center"}}>
                <Link
                  text="Kontak aufnehmen"
                  href="/contact"
                  className="portfolio-repo-btn"
                />
              	</div>
              </div>
            </div>
          </Fade>
        </div>
      </div>
      
      
      <div className="auszubildende main">
				<div className="row justify-content-center">
							<div className="col-lg-4 mb-5">
								<Fade direction="left" duration={1000} triggerOnce={true} className="h-100">
								<div className="textcard-item text-center h-100">
									<div className="textcard-icon">
										<span
											className="iconify"
											data-icon="mdi:account-school-outline"
											style={{ color: "var(--primary)", fontSize: "45px" }}
											data-inline="false"
										></span>
									</div>
									<div className="textcard-headline ">
										<h3>{t("leistung.1")}</h3>
									</div>
									<div className="textcard-text">
										<p>{t("leistung.1.desc")}</p>
									</div>
									{/*<div className="textcard-more">
										<a href="/vorteile#c12" title="Mehr erfahren" className="link-dpaii">{t("link.more")}</a>
									</div>*/}
								</div>
								</Fade>
							</div>
							
							<div className="col-lg-4 mb-5">
								<Fade direction="down" duration={1000} triggerOnce={true} className="h-100">
								<div className="textcard-item text-center h-100">
									<div className="textcard-icon">
										<span
											className="iconify"
											data-icon="mdi:account-tie"
											style={{ color: "var(--primary)", fontSize: "45px" }}
											data-inline="false"
										></span>
									</div>
									<div className="textcard-headline ">
										<h3>{t("leistung.2")}</h3>
									</div>
									<div className="textcard-text">
										<p>{t("leistung.2.desc")}</p>
									</div>
									{/*<div className="textcard-more">
																			<a href="/vorteile#c12" title="Mehr erfahren" className="link-dpaii">{t("link.more")}</a>
																		</div>*/}
								</div>
								</Fade>
							</div>

							<div className="col-lg-4 mb-5">
								<Fade direction="right" duration={1000} triggerOnce={true} className="h-100">
								<div className="textcard-item text-center h-100">
									<div className="textcard-icon">
										<span
											className="iconify"
											data-icon="mdi:account-supervisor"
											style={{ color: "var(--primary)", fontSize: "45px" }}
											data-inline="false"
										></span>
									</div>
									<div className="textcard-headline ">
										<h3 style={{ wordWrap: "break-word" }}>{t("leistung.3")}</h3>
									</div>
									<div className="textcard-text">
										<p>
											{t("leistung.3.desc")}
										</p>
									</div>
									{/*<div className="textcard-more">
																			<a href="/vorteile#c12" title="Mehr erfahren" className="link-dpaii">{t("link.more")}</a>
																		</div>*/}
								</div>
								</Fade>
							</div>
							
							<div className="col-lg-4 mb-5">
								<Fade direction="left" duration={1000} triggerOnce={true} className="h-100">
								<div className="textcard-item text-center h-100">
									<div className="textcard-icon">
										<span
											className="iconify"
											data-icon="mdi:cash-clock"
											style={{ color: "var(--primary)", fontSize: "45px" }}
											data-inline="false"
										></span>
									</div>
									<div className="textcard-headline ">
										<h3>{t("leistung.4")}</h3>
									</div>
									<div className="textcard-text">
										<p>{t("leistung.4.desc")}</p>
									</div>
									{/*<div className="textcard-more">
																			<a href="/vorteile#c12" title="Mehr erfahren" className="link-dpaii">{t("link.more")}</a>
																		</div>*/}
								</div>
								</Fade>
							</div>
							
							<div className="col-lg-4 mb-5">
								<Fade direction="down" duration={1000} triggerOnce={true} className="h-100">
								<div className="textcard-item text-center h-100">
									<div className="textcard-icon">
										<span
											className="iconify"
											data-icon="mdi:chart-timeline-variant-shimmer" 
											style={{ color: "var(--primary)", fontSize: "45px" }}
											data-inline="false"
										></span>
									</div>
									<div className="textcard-headline ">
										<h3>{t("leistung.5")}</h3>
									</div>
									<div className="textcard-text">
										<p>{t("leistung.5.desc")}</p>
									</div>
									{/*<div className="textcard-more">
																			<a href="/vorteile#c12" title="Mehr erfahren" className="link-dpaii">{t("link.more")}</a>
																		</div>*/}
								</div>
								</Fade>
							</div>

							
							
				</div>        
      
      </div>
			<Branchenkompetenz theme={theme} />
     
			<div className="main">
				<h1 className="projects-heading-text">{t('leistung.future.title')}</h1>
				<div dangerouslySetInnerHTML={
				    {__html: t('leistung.future.desc', {interpolation: {escapeValue: false}})}
				} />
				
				<div dangerouslySetInnerHTML={
								    {__html: t('leistung.future.kontakt', {interpolation: {escapeValue: false}})}
								} />
								<div className="portfolio-repo-btn-div" style={{display:"flex",justifyContent:"center"}}>
								                <Link
								                  text="Kontak aufnehmen"
								                  href="/contact"
								                  className="portfolio-repo-btn"
								                />
								              	</div>
																				
			</div>								
      </PageLayout>
    );
}